import Driver from "~/utils/driver-utils";

export default defineNuxtPlugin({
  name: "driver-plugin",
  parallel: true,
  setup(nuxtApp) {
    nuxtApp.provide("driver", Driver);
  },
});

declare module "nuxt/app" {
  interface NuxtApp {
    $driver: typeof Driver;
  }
}

declare module "@vue/runtime-core" {
  interface ComponentCustomProperties {
    $driver: typeof Driver;
  }
}
